import React from "react";

export const PlanDateContext = React.createContext(null);

export const withPlanDate = (Component) => (props) => {
  return (
    <PlanDateContext.Consumer>
      {(planDate) => <Component {...props} planDate={planDate} />}
    </PlanDateContext.Consumer>
  );
};
